export default "__VITE_ASSET__Bqe3ffQa__"